require('../modules/web.timers');
module.exports = require('../modules/_core');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/web/timers.js
// module id = 901
// module chunks = 10